import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import SeoHead from "@/components/feature/SeoHead";
import { Link } from "react-router-dom";
import { faqs, siteInfo } from "@/mocks/site";
import Hero from "./components/Hero";
import HotCases from "./components/HotCases";
import CategoryGrid from "./components/CategoryGrid";
import ArchiveTimeline from "./components/ArchiveTimeline";
import Principles from "./components/Principles";
import Testimonials from "./components/Testimonials";
import FaqSection from "./components/FaqSection";

const Home = () => {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: siteInfo.name,
      url: "https://hnhxedu.cn/",
      description:
        "起底网红塌房背后的旧料与黑历史，汇总过往言论、历史爆料与黑料合集，一次看完旧账翻出的全过程。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target:
          "https://hnhxedu.cn/cases?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: siteInfo.name,
      url: "https://hnhxedu.cn/",
      description: siteInfo.intro,
      email: siteInfo.email,
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <SeoHead
        title="塌房档案局 - 网红塌房黑历史与旧料被扒合集"
        description="起底网红塌房背后的黑历史与旧料，汇总过往言论、历史爆料和黑料合集，一次看完网红塌房旧账翻出全过程，吃瓜不迷路。"
        keywords="网红塌房,网红塌房黑历史,网红塌房旧料被扒,网红塌房黑料合集"
        path="/"
        jsonLd={jsonLd}
      />
      <SiteHeader overlay />

      <main>
        <Hero />
        <HotCases />
        <CategoryGrid />
        <ArchiveTimeline />
        <Principles />
        <Testimonials />
        <FaqSection />

        <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto text-center bg-background-50 border border-background-200/80 rounded-lg px-6 py-10 md:px-12 md:py-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
              手上也有没被整理过的旧料？
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
              把你看到的线索告诉我们，编辑会先做来源核对，确认公开可查之后再纳入整理队列，
              让更多人少走弯路。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/about#submit"
                className="w-full sm:w-auto px-7 py-3 rounded-md text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                我要爆料
              </Link>
              <Link
                to="/cases"
                className="w-full sm:w-auto px-7 py-3 rounded-md text-sm md:text-base font-medium border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                先逛逛合集
              </Link>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
      <BackToTop />
    </div>
  );
};

export default Home;